import React, { useState, memo } from "react";
import { Button, Typography, Box, Backdrop, Stack } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import { IconButton, Tooltip, CircularProgress } from "../../../../components";

import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { KEEPA_DURATIONS } from "../../../../constants";
import { Dummy } from "../../../../utils";
import { selectKeepaData } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { getKeepaThunk } from "../../../../features/productAnalyzer/productAnalyzer.thunk";
import { useProductAnalyzer } from "../../../../contexts/productAnalyzerContext";

import { useStyles } from "./index.styles";

const Keepa: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { asin } = useProductAnalyzer();
  const { keepaData, loadingKeepaData } = useAppSelector(selectKeepaData);
  const [day, setDay] = useState<number>(KEEPA_DURATIONS[1]);

  const handleDaySelect = (value: number) => {
    setDay(value);
    dispatch(getKeepaThunk({ asin, country: "US", day: value }));
  };

  const handleRefresh = () => {
    dispatch(getKeepaThunk({ asin, country: "US", day }));
  };

  return (
    <Stack>
      <Box position="relative">
        <Box
          component="a"
          href={`https://keepa.com/#!product/1-${asin}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            borderTop: "1px solid #E9EAEB",
            borderBottom: "1px solid #E9EAEB",
            cursor: "pointer",
          }}
        >
          <Box p="16px 4px">
            <img
              src={keepaData || Dummy}
              alt="Keepa chart"
              className={classes.keepaImg}
            />
          </Box>
        </Box>

        {loadingKeepaData && (
          <Backdrop open={true} sx={{ position: "absolute", zIndex: 999 }}>
            <CircularProgress size="md" />
          </Backdrop>
        )}
      </Box>

      <Box
        display={"flex"}
        gap={"4px"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        padding="4px 4px"
      >
        <Box display={"flex"} alignItems={"center"} gap={"4px"}>
          <Typography variant="body1">Days:</Typography>
          {KEEPA_DURATIONS.map((value) => (
            <Button
              key={value}
              size="small"
              variant={day === value ? "contained" : "outlined"}
              onClick={() => handleDaySelect(value)}
            >
              {value}
            </Button>
          ))}
        </Box>

        <Tooltip title="Refresh">
          <IconButton size="small" color="primary" onClick={handleRefresh}>
            <RefreshOutlinedIcon sx={{ fontSize: "18px" }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default memo(Keepa);
